/**
 * Radio group component type definitions
 */

export enum RadioGroupSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum RadioGroupOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
